function inPath () {
    return window.location.pathname.match(new RegExp('^/((ca|au)/)?'))[0]
}
